// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Phone, Plus, Search } from 'lucide-react';

export default function BannedVehicleScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data from navigation state
  const { vrn, notes, controlCentreNumber } = location.state || {};
  
  // Vibrate on load
  useEffect(() => {
    if (navigator.vibrate) {
      navigator.vibrate(300);
    }
  }, []);
  
  // Fallback if no state
  if (!vrn) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ backgroundColor: '#C8102E' }}>
        <p className="text-white mb-4">No vehicle data found</p>
        <button
          onClick={() => navigate('/')}
          className="h-12 px-6 bg-white rounded-xl font-semibold"
          style={{ color: '#C8102E' }}
        >
          Go Home
        </button>
      </div>
    );
  }

  const handleLogSighting = () => {
    navigate('/log-sighting', { state: { vrn } });
  };

  const handleCheckAnother = () => {
    navigate('/');
  };

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center px-6 py-10"
      style={{ backgroundColor: '#C8102E' }}
      data-testid="banned-vehicle-screen"
    >
      {/* BANNED VEHICLE Label */}
      <h1 
        className="text-white font-bold text-center mb-8"
        style={{ fontSize: '2.5rem', letterSpacing: '0.05em' }}
        data-testid="banned-label"
      >
        BANNED VEHICLE
      </h1>

      {/* VRN in yellow plate style */}
      <div 
        className="mb-6 py-4 px-8 rounded"
        style={{ 
          backgroundColor: '#FFC425',
          border: '3px solid #000000'
        }}
        data-testid="vrn-display"
      >
        <p 
          className="text-black font-bold text-center"
          style={{ 
            fontSize: '2rem',
            fontFamily: '"Courier New", Courier, monospace',
            letterSpacing: '0.15em'
          }}
        >
          {vrn}
        </p>
      </div>

      {/* Notes if present */}
      {notes && (
        <p 
          className="text-white text-center mb-8 max-w-sm italic"
          style={{ fontSize: '1.1rem' }}
          data-testid="notes-display"
        >
          {notes}
        </p>
      )}

      {/* Spacer */}
      <div className="flex-1 min-h-8" />

      {/* Action Buttons */}
      <div className="w-full max-w-sm space-y-4">
        {/* Contact Control Centre - only if number is set */}
        {controlCentreNumber && (
          <a
            href={`tel:${controlCentreNumber}`}
            className="w-full h-14 bg-white flex items-center justify-center gap-3 rounded-xl font-bold text-lg active:scale-[0.98] transition-transform"
            style={{ color: '#C8102E' }}
            data-testid="contact-control-btn"
          >
            <Phone className="w-5 h-5" />
            <span>Contact Control Centre</span>
          </a>
        )}

        {/* Log a Sighting */}
        <button
          onClick={handleLogSighting}
          className="w-full h-14 bg-transparent border-2 border-white text-white font-semibold rounded-xl flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
          data-testid="log-sighting-btn"
        >
          <Plus className="w-5 h-5" />
          <span>Log a Sighting</span>
        </button>

        {/* Check Another Vehicle */}
        <button
          onClick={handleCheckAnother}
          className="w-full h-14 bg-transparent border-2 border-white text-white font-semibold rounded-xl flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
          data-testid="check-another-btn"
        >
          <Search className="w-5 h-5" />
          <span>Check Another Vehicle</span>
        </button>
      </div>
    </div>
  );
}
